import { UserEmailDetails } from "../types/userTypes";

export const changeUserEmailInitialValues: UserEmailDetails = {
  email: "",
};
